import React from 'react';
import Deck from '../deck';

import './app.scss';
import './responsive.scss';

function App (props) {
  return (
    <div className="data-cards container">
      <Deck contactUsUrl={props.settings["contact-us-url"]} />
    </div>
  )
}

export default App;
